import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet'; // Import react-helmet for SEO
import './App.css'; // Import the custom CSS

// Import components for different pages
import Logo from './img/Tab.png';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import FAQ from './components/FAQ';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Router>
      <div className="App">
        {/* Global Helmet for website-wide metadata */}
        <Helmet>
          {/* Page Title & Meta Description */}
          <title>Doggy Duty WNY | Pet Waste Removal in Amherst, NY</title>
          <meta 
            name="description" 
            content="Doggy Duty WNY offers professional pet waste removal services in Amherst, NY, and surrounding areas. Keep your yard clean and safe—get a free quote today!" 
          />
          <meta 
            name="keywords" 
            content="dog poop removal Amherst NY, pet waste removal Amherst, pooper scooper service Buffalo, yard cleaning for dogs, pet waste disposal Amherst NY" 
          />
          <meta name="author" content="Doggy Duty WNY" />

          {/* Open Graph (Facebook) Meta Tags */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content="Doggy Duty WNY | Pet Waste Removal in Amherst, NY" />
          <meta property="og:description" content="We provide reliable pet waste removal in Amherst, NY, and nearby areas. Keep your yard clean and odor-free!" />
          <meta property="og:url" content="https://doggydutywny.com" />
          <meta property="og:image" content="https://doggydutywny.com/logo.png" />

          {/* Twitter Card Meta Tags */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Doggy Duty WNY | Amherst's Trusted Pet Waste Removal" />
          <meta name="twitter:description" content="Reliable pet waste removal in Amherst, NY. Keep your yard clean and fresh. Get a free quote today!" />
          <meta name="twitter:image" content="https://doggydutywny.com/logo.png" />

          {/* Favicon Links */}
          <link rel="icon" href="/tablogo/reizee.png" sizes="32x32" />
          <link rel="icon" href="/tablogo/reizee.png" sizes="192x192" />
          <link rel="apple-touch-icon" href="/tablogo/reizee.png" />

          {/* Structured Data (Schema.org) */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Doggy Duty WNY",
              "url": "https://doggydutywny.com",
              "logo": "https://doggydutywny.com/logo.png",
              "description": "Professional pet waste removal service located in Amherst, NY. Serving Buffalo, Tonawanda, Williamsville, and surrounding areas.",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Amherst, NY",
                "addressLocality": "Amherst",
                "addressRegion": "NY",
                "postalCode": "14228",
                "addressCountry": "US"
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+1-716-260-9249",
                "contactType": "Customer Service"
              },
              "serviceArea": {
                "@type": "GeoCircle",
                "geoMidpoint": {
                  "@type": "GeoCoordinates",
                  "latitude": 42.9784,
                  "longitude": -78.7998
                },
                "geoRadius": "25"
              }
            })}
          </script>
        </Helmet>

        <header>
          <nav fixed="top" bg="dark" variant="dark">
            <div className="navbar-container">
              {/* Logo */}
              <div className="logo-container">
                <a href="/">
                  <img
                    src={Logo}
                    alt="Doggy Duty WNY - Pet Waste Removal Service"
                    className="img-fluid logo"
                  />
                </a>
              </div>

              {/* Menu Toggle Button */}
              <button className="menu-toggle" onClick={toggleMenu}>
                {menuOpen ? '⨯' : '☰'}
              </button>

              {/* Navigation Menu */}
              <ul className={`nav-menu ${menuOpen ? 'open' : ''}`}>
                <li>
                  <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
                </li>
                <li>
                  <Link to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
                </li>
                <li>
                  <Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link>
                </li>
                <li>
                  <Link to="/faq" onClick={() => setMenuOpen(false)}>FAQ</Link>
                </li>
                <li>
                  <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact Us</Link>
                </li>
              </ul>
            </div>
          </nav>
        </header>

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/faq" element={<FAQ />} />
          </Routes>
        </main>

        {/* Footer with NAP information */}
        <footer> 
          <p>&copy; 2025 Doggy Duty - Waste Removal Service  |   Amherst, NY  |   <a href="tel:7162609249">(716)-260-9249</a></p>
          <p>Phone: <a href="tel:7162609249">(716)-260-9249</a></p>
          <p>Email: <a href="mailto:info@brothersmovingco.com">info@brothersmovingco.com</a></p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
